
import { Options, prop, Vue } from "vue-class-component";
import moment from "moment";
import DateTimeInput from "./index.vue";

class Props {
  title = prop<string>({ default: "Tanggal dan jam" });
  placeholder = prop<string>({ default: "Pilih tanggal dan jam" });
  minDate = prop<Date>({ default: () => new Date() });
  modelValue = prop<Date | null>({ default: null });
  disabled = prop<boolean>({ default: false, type: Boolean });
  dataTestid = prop<string>({ default: "date-time-input-trigger" });
  validateTodayMinHour = prop<boolean>({
    default: false,
    type: Boolean
  })
}

@Options({
  name: "DateTimeInputField",
  components: {
    DateTimeInput
  }
})
export default class DateTimeInputField extends Vue.with(Props) {
  isModalVisible = false;

  get displayValue() {
    if (!this.modelValue) {
      return "";
    }

    return moment(this.modelValue)
      .locale("id")
      .format("DD MMM YYYY, HH:mm [WIB]");
  }

  openModal() {
    if (this.disabled) {
      return;
    }

    this.isModalVisible = true;
  }

  onUpdateModelValue(value: Date) {
    this.$emit("update:modelValue", value);
  }
}
